import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
import { ActionsAreaLarge, GlobalActionsMedium, GlobalActionsSmall, MainActionsMedium, MainActionsSmall, TableTitle, } from '../DataTable/components';
import { TreeContent, TreeSurface } from './components';
export function DataTree(props) {
    var _a, _b;
    const upSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const upMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const showHeader = props.title ||
        props.mainAction ||
        props.secondaryAction ||
        (props.globalActions && props.globalActions.length > 0) ||
        props.customHeaderElement;
    const TreeSurfaceComponent = (_a = props.customTreeSurfaceComponent) !== null && _a !== void 0 ? _a : TreeSurface;
    const TreeContentComponent = (_b = props.customTreeContentComponent) !== null && _b !== void 0 ? _b : TreeContent;
    return (React.createElement(Box, null,
        showHeader && (React.createElement(Box, { sx: {
                mb: 2,
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: { xs: 'stretch', md: 'center' },
                gap: 2,
            } },
            React.createElement(Box, { sx: { flexShrink: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
                React.createElement(TableTitle, Object.assign({}, props))),
            props.customHeaderElement,
            upMd ? (React.createElement(ActionsAreaLarge, Object.assign({}, props))) : upSm ? (React.createElement(React.Fragment, null,
                React.createElement(MainActionsMedium, Object.assign({}, props)),
                React.createElement(GlobalActionsMedium, Object.assign({}, props)))) : (React.createElement(React.Fragment, null,
                React.createElement(MainActionsSmall, Object.assign({}, props)),
                React.createElement(GlobalActionsSmall, Object.assign({}, props)))))),
        React.createElement(TreeSurfaceComponent, null,
            props.filtersBar && React.createElement(Box, { p: 2 }, props.filtersBar),
            React.createElement(TreeContentComponent, Object.assign({}, props)),
            props.customContentElement)));
}
